import { useRef, useEffect } from "react";

const Filler: React.FC = () => {
  // Use `useRef<HTMLVideoElement>(null!)` to bypass the null issue
  const videoRef = useRef<HTMLVideoElement>(null!);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.25;
    }
  }, []);

  return (
    <div className="relative flex-grow p-4 bg-zinc-800 justify-center items-center overflow-hidden hidden md:block">
      <video
        className="absolute top-0 left-0 w-full h-full object-cover filter blur-xs md:blur-md"
        ref={videoRef}
        autoPlay
        loop
        muted
        playsInline
      >
        <source src="/placeholder-hero.webm" type="video/webm" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default Filler;
